import {IComponentOptions, ILogService} from "angular";
import {Application} from "../../../shared/model/Application";
import {isSystemAccepted as checkSystemAccepted} from "../../../shared/model/ApplicationStatusUtil";

class StaffApplicationFooterController {

    private application: Application;

    /* @ngInject */
    constructor(private $log: ILogService) {
    }

    /**
     * Check if the application status indicates system accepted.
     */
    public isSystemAccepted(): boolean {
        return checkSystemAccepted(this.application.status);
    }

}

export const StaffApplicationFooterComponent: IComponentOptions = {
    bindings: {
        application: "=",
        actionsDisabled: "<",
        onApprove: "&",
        onDecline: "&",
        onReopenApplication: "&",
        onResetApplicationStatus: "&",
        onReopenSummary: "&",
        onReallocateFaculty: "&",
        enableApprove: "&"
    },
    controller: StaffApplicationFooterController,
    template: require("./staff-application-footer.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/footer/staff-application-footer.component.ts